module.exports = __webpack_public_path__ + "static/man-0703acbeb25fecba3aefdee257c4e976.jpg";